import { render } from "./SubProductsList.vue?vue&type=template&id=61eb1cd6&scoped=true"
import script from "./SubProductsList.vue?vue&type=script&lang=js"
export * from "./SubProductsList.vue?vue&type=script&lang=js"

import "./SubProductsList.vue?vue&type=style&index=0&id=61eb1cd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61eb1cd6"]])

export default __exports__